var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.409302,
    y: 0.331909,
    width: 23.5972,
    height: 23.5972,
    fill: "url(#pattern0)",
    fillOpacity: 0.85
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_205_871",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_205_871",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAABpUlEQVR4nO3TwRHDQAhDUfpvWrlmuHh22CBw/mtAWPJGAAAAAECiYeKBhin/UBomXnYvA/wYA5gxgBkDmDGAGQO8fYBywOW8bff6AxIGuFzIKRXztt3rD0gY4HIhp1TM23avPyBhgMuFnFIxb9u9/oCEAS4XckrFvG33+gMSBrhcyCkV87bd6w9IGOByIdMG6GYvpDtPw9gL6c7TMPZCuvM0jL2Q7jwNYy+kO0/D2AvpztMw9kK68zSMvZDpeeMxgBkDmDGAGQOYMYAZA5gxgJmGiZfdywA/xgBmDGDGAGYMYMYAZgywfYBt1FwIAyQMYCZeAAN8i3+jB9vzxhMDMMC3+Dd6sC5Pw4S7kO48DRPuQrrzNEy4C+nO0zDhLqQ7T8OEu5DuPA0T7kK68zRMuAvpztMw4S6kO2/bB2nZvf6AhAEuF3JKxbxt9/oDEga4XMgpFfO23esPSBjgciGnVMzbdq8/IGGAy4WcUjFv273+gIQBLhdySsW8bff6AxIGOCykWzzQsnsfaZh42b0M8GMMYMYAZgxgxgBmDLB9AAAAAADxNh8O3ss62/NOUAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.9e640d2469266a0c5d99240f29d84b7e.svg";
export { ForwardRef as ReactComponent };